import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useMemo } from 'react';
import { getFeaturedProperties } from '../services/api';
import { FaBath, FaBed, FaRuler, FaMapMarkerAlt, FaEye } from 'react-icons/fa';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropertyCard from './PropertyCard';


const FeaturedProperties = () => {

    const navigate = useNavigate();
    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const isGrid = true; // Cambiar a false para vista de lista

    const placeholderImage = useMemo(() => {
        const svg = `
          <svg width="400" height="300" xmlns="http://www.w3.org/2000/svg">
            <rect width="100%" height="100%" fill="#0D0D0D"/>
            <rect x="20" y="20" width="360" height="260" fill="none" stroke="#D4AF37" stroke-width="2" stroke-dasharray="10,5"/>
            <g transform="translate(200,120)">
              <rect x="-40" y="-30" width="80" height="60" fill="#D4AF37" opacity="0.3"/>
              <circle cx="-15" cy="-10" r="8" fill="#D4AF37"/>
              <path d="M-5,-5 L15,-5 L10,5 L-5,5 Z" fill="#D4AF37"/>
            </g>
            <text x="200" y="200" text-anchor="middle" fill="#D4AF37" font-family="Arial, sans-serif" font-size="18" font-weight="bold">
              Imagen no disponible
            </text>
          </svg>
        `;
        return `data:image/svg+xml;base64,${btoa(svg)}`;
    }, []);
    const formatPrice = (price) => {
        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(price);
    };

    useEffect(() => {
        const loadProperties = async () => {
            try {
                setLoading(true);
                const data = await getFeaturedProperties();
                setProperties(data);
                // console.log('Featured properties loaded:', data);

            } catch (error) {
                setError('Error al cargar las propiedades destacadas.');
                console.error('Error fetching featured properties:', error);
            } finally {
                setLoading(false);
            }
        };
        loadProperties();
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };




    if (loading) {
        return <div>Cargando propiedades destacadas...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (

        <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center py-8 text-brand-gold">Propiedades Destacadas</h2>
            <div className="relative">
                <Slider {...settings}>
                    {properties.map((inmueble) => (
                       <div key={inmueble.consecutivo} className="px-2 text-brand-white">
                        <PropertyCard
                            key={inmueble.consecutivo}
                            inmueble={inmueble}
                            isGrid={isGrid}
                            isHome={true}
                            />
                          </div>
                    ))}
                </Slider>
            </div>
        </div>

    );
};
export default FeaturedProperties;